<template>
  <div
    v-if="showLoadingState < 4"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="billingSalesDataCreateData"
  >
    <form
      autocomplete="off"
      class="margin-top-large"
      @submit.prevent="updateAcademiaDatosPersona"
    >
      <fieldset class="m-form-fieldset m-form-fieldset-step-connected">
        <legend class="legend-academy">
          <span class="legend-icon">
            <i class="fas fa-map-marker-alt"></i>
          </span>
          {{ $t('mEditionAcademyData.fieldsets.steps.first') }}
        </legend>

        <div class="m-container-primary">
          <div class="row">
            <div class="column column-3">
              <AtomSelectPrimaryTimeout
                v-model.number="academyData.pais"
                :elements="paises"
                :input-error="$v.academyData.pais.$error"
                key-field="id_pais"
                :label="$t('mEditionAcademyData.inputs.pais.label')"
                :message-error="messageErrorPais"
                name="pais"
                reference="pais"
                text-field="nombre"
                @blur="$v.academyData.pais.$touch()"
                @input="readParametroDocumentoTipos($event); readParametroProvincias($event)"
              />
            </div>

            <div class="column column-3">
              <AtomSelectPrimary
                v-model.number="academyData.provincia"
                :elements="provincias"
                :input-error="$v.academyData.provincia.$error"
                key-field="id_provincia"
                :label="$t('mEditionAcademyData.inputs.provincia.label')"
                :message="!academyData.pais ? $t('mEditionAcademyData.inputs.provincia.message') : ''"
                :message-error="messageErrorProvincia"
                name="provincia"
                reference="provincia"
                text-field="nombre"
                @blur="$v.academyData.provincia.$touch()"
              />
            </div>

            <div class="column column-4">
              <AtomInputPrimary
                v-model="academyData.localidad"
                :label="$t('mEditionAcademyData.inputs.localidad.label')"
                name="localidad"
                reference="localidad"
                type="text"
              />
            </div>
          </div>

          <div class="row">
            <div class="column column-2">
              <AtomInputPrimary
                v-model="academyData.cod_postal"
                :input-error="$v.academyData.cod_postal.$error"
                :label="$t('mEditionAcademyData.inputs.cod_postal.label')"
                :message-error="messageErrorCodigoPostal"
                :message="$t('mEditionAcademyData.inputs.cod_postal.message')"
                name="cod_postal"
                reference="cod_postal"
                type="text"
                @blur="$v.academyData.cod_postal.$touch()"
              />
            </div>

            <div class="column column-4">
              <AtomInputPrimary
                v-model="academyData.linea1"
                :input-error="$v.academyData.linea1.$error"
                :label="$t('mEditionAcademyData.inputs.linea1.label')"
                :message-error="messageErrorLinea1"
                :message="$t('mEditionAcademyData.inputs.linea1.message')"
                name="linea1"
                reference="linea1"
                type="text"
                @blur="$v.academyData.linea1.$touch()"
              />
            </div>

            <div class="column column-4">
              <AtomInputPrimary
                v-model="academyData.linea2"
                :label="$t('mEditionAcademyData.inputs.linea2.label')"
                name="linea2"
                reference="linea2"
                type="text"
              />
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset class="m-form-fieldset m-form-fieldset-step-connected">
        <legend class="legend-academy">
          <span class="legend-icon">
            <i class="fas fa-balance-scale"></i>
          </span>
          {{ $t('mEditionAcademyData.fieldsets.steps.second') }}
        </legend>

        <div class="m-container-primary">
          <div class="row">
            <div class="column column-4">
              <AtomSelectPrimary
                v-model.number="academyData.fisica"
                :elements="$filters.parameters.persons"
                :input-error="$v.academyData.fisica.$error"
                keyField="id"
                :label="$t('mEditionAcademyData.inputs.fisica.label')"
                :message-error="messageErrorFisica"
                name="fisica"
                reference="fisica"
                text-field="name"
                @blur="$v.academyData.fisica.$touch()"
              />
            </div>

            <div class="column column-6">
              <AtomInputPrimary
                v-model="academyData.razon_social"
                :input-error="$v.academyData.razon_social.$error"
                :label="academyData.fisica === 0
                  ? $t('mEditionAcademyData.inputs.razon_social.labelBusiness')
                  : $t('mEditionAcademyData.inputs.razon_social.labelName')"
                :message="$t('mEditionAcademyData.inputs.razon_social.message')"
                :message-error="messageErrorRazonSocial"
                name="razon_social"
                reference="razon_social"
                type="text"
                @blur="$v.academyData.razon_social.$touch()"
              />
            </div>
          </div>

          <div class="row">
            <div class="column column-4">
              <AtomSelectPrimary
                v-model.number="academyData.documento_tipo"
                :elements="documentoTipos"
                :input-error="$v.academyData.documento_tipo.$error"
                key-field="id_documento_tipo"
                :message="!academyData.pais ? $t('mEditionAcademyData.inputs.documento_tipo.message') : ''"
                :message-error="messageErrorTipoDoc"
                :label="$t('mEditionAcademyData.inputs.documento_tipo.label')"
                name="documento_tipo"
                reference="documento_tipo"
                text-field="nombre"
                @blur="$v.academyData.documento_tipo.$touch()"
              />
            </div>

            <div class="column column-6">
              <AtomInputPrimary
                v-model="academyData.documento_numero"
                :input-error="$v.academyData.documento_numero.$error"
                :label="$t('mEditionAcademyData.inputs.documento_numero.label')"
                :message="$t('mEditionAcademyData.inputs.documento_numero.message')"
                :message-error="messageErrorDocumentoNum"
                name="documento_numero"
                reference="documento_numero"
                type="text"
                @blur="$v.academyData.documento_numero.$touch()"
              />
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset class="m-form-fieldset m-form-fieldset-step-connected">
        <legend class="legend-academy">
          <span class="legend-icon">
            <i class="fas fa-mobile-alt"></i>
          </span>
          {{ $t('mEditionAcademyData.fieldsets.steps.third') }}
        </legend>

        <div class="m-container-primary">
          <div class="row">
            <div class="column column-5">
              <AtomInputPrimary
                v-model="academyData.telefono"
                :input-error="$v.academyData.telefono.$error"
                :label="$t('mEditionAcademyData.inputs.telefono.label')"
                :message-error="messageErrorTelefono"
                name="telefono"
                reference="telefono"
                type="text"
                @blur="$v.academyData.telefono.$touch()"
              />
            </div>

            <div class="column column-5">
              <AtomInputPrimary
                v-model="academyData.movil"
                :input-error="$v.academyData.movil.$error"
                :label="$t('mEditionAcademyData.inputs.movil.label')"
                :message-error="messageErrorMovil"
                name="movil"
                reference="movil"
                type="text"
                @blur="$v.academyData.movil.$touch()"
              />
            </div>
          </div>
        </div>
      </fieldset>

      <div class="m-form-action">
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </div>
    </form>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators'

export default {
  name: 'MoleculeEditionAcademyData',

  data () {
    return {
      academyData: {
        cod_postal: '',
        documento_numero: '',
        documento_tipo: '',
        fisica: 1,
        imagen: '',
        linea1: '',
        linea2: '',
        localidad: '',
        movil: '',
        pais: '',
        provincia: '',
        razon_social: '',
        telefono: ''
      },

      buttonPrimary: {
        action: 'GUARDAR',
        class: 'a-button-academy-primary',
        sending: false,
        type: 'submit'
      },

      documentoTipos: [],
      pais: 0,
      paises: [],

      provincias: [],
      selected: '',
      showLoadingState: 0
    }
  },

  validations: {
    academyData: {
      cod_postal: {
        maxLength: maxLength(10),
        minLength: minLength(1),
        required
      },

      documento_numero: {
        maxLength: maxLength(30),
        minLength: minLength(3),
        required
      },

      documento_tipo: {
        required
      },

      fisica: {
        required
      },

      linea1: {
        maxLength: maxLength(120),
        minLength: minLength(1),
        required
      },

      movil: {
        required
      },

      pais: {
        required
      },

      provincia: {
        required
      },

      razon_social: {
        maxLength: maxLength(150),
        minLength: minLength(3),
        required
      },

      telefono: {
        required
      }
    }
  },

  computed: {
    messageErrorCodigoPostal () {
      return this.$validation.getValidationMessage('mEditionAcademyData', this.$v.academyData.cod_postal, 'cod_postal')
    },

    messageErrorDocumentoNum () {
      return this.$validation.getValidationMessage('mEditionAcademyData', this.$v.academyData.documento_numero, 'documento_numero')
    },

    messageErrorFisica () {
      return this.$validation.getValidationMessage('mEditionAcademyData', this.$v.academyData.fisica, 'fisica')
    },

    messageErrorLinea1 () {
      return this.$validation.getValidationMessage('mEditionAcademyData', this.$v.academyData.linea1, 'linea1')
    },

    messageErrorMovil () {
      return this.$validation.getValidationMessage('mEditionAcademyData', this.$v.academyData.movil, 'movil')
    },

    messageErrorPais () {
      return this.$validation.getValidationMessage('mEditionAcademyData', this.$v.academyData.pais, 'pais')
    },

    messageErrorProvincia () {
      return this.$validation.getValidationMessage('mEditionAcademyData', this.$v.academyData.provincia, 'provincia')
    },

    messageErrorRazonSocial () {
      return this.$validation.getValidationMessage('mEditionAcademyData', this.$v.academyData.razon_social, 'razon_social')
    },

    messageErrorTelefono () {
      return this.$validation.getValidationMessage('mEditionAcademyData', this.$v.academyData.telefono, 'telefono')
    },

    messageErrorTipoDoc () {
      return this.$validation.getValidationMessage('mEditionAcademyData', this.$v.academyData.documento_tipo, 'documento_tipo')
    }
  },

  watch: {
    'academyData.pais' () {
      if (this.academyData.pais !== this.selected) {
        this.academyData.provincia = ''
        this.academyData.documento_tipo = ''
        this.selected = this.academyData.pais
      }
    }
  },

  created () {
    this.readAcademia()
    this.readParametroPaises()
  },

  methods: {
    readAcademia () {
      this.$services.read('academia', 'readAcademiaDatos', {}, [this.$store.getters.getAcademyData.id])
        .then(response => {
          if (response.data.persona) {
            this.selected = response.data.persona.domicilio.provincia.pais.id_pais
            this.academyData = {
              cod_postal: response.data.persona.domicilio.codigo_postal,
              documento_numero: response.data.persona.documento.numero,
              documento_tipo: response.data.persona.documento.tipo.id_documento_tipo,
              fisica: +response.data.persona.fisica,
              linea1: response.data.persona.domicilio.linea1,
              linea2: response.data.persona.domicilio.linea2,
              localidad: response.data.persona.domicilio.localidad,
              movil: response.data.persona.movil,
              pais: response.data.persona.domicilio.provincia.pais.id_pais,
              provincia: response.data.persona.domicilio.provincia.id_provincia,
              razon_social: response.data.persona.razon_social,
              telefono: response.data.persona.telefono
            }
            this.readParametroDocumentoTipos(this.academyData.pais)
            this.readParametroProvincias(this.academyData.pais)
          } else {
            this.showLoadingState++
            this.showLoadingState++
          }
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readParametroDocumentoTipos (idPais) {
      this.$services.read('parametro', 'readParametroDocumentoTipos', {}, [idPais])
        .then(response => {
          this.documentoTipos = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.documentoTipos = []
          this.showLoadingState++
        })
    },

    readParametroPaises () {
      this.$services.read('parametro', 'readParametroPaises')
        .then(response => {
          this.paises = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readParametroProvincias (idPais) {
      this.$services.read('parametro', 'readParametroProvincias', {}, [idPais])
        .then(response => {
          this.provincias = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.provincias = []
          this.showLoadingState++
        })
    },

    updateAcademiaDatosPersona () {
      this.$v.$touch()
      this.$nextTick(() => this.$validation.focusInputError(this))
      if (!this.buttonPrimary.sending && !this.$v.$invalid) {
        this.buttonPrimary.sending = true
        this.$services.create('academia', 'updateAcademiaDatosPersona', this.academyData, [this.$store.getters.getAcademyData.id])
          .then(response => {
            let academyData = Object.assign({}, this.$store.getters.getAcademyData)
            academyData.persona = Object.assign({}, response.data)
            localStorage.setItem('current_academy', JSON.stringify(academyData))
            this.$store.commit('setAcademyData', academyData)
            this.$license.readAcademiaConfiguracionGlobal()
            this.$alerts.pushAlert('mEditionAcademyData', 'updateAcademiaDatosPersona', 'success')
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionAcademyData', 'updateAcademiaDatosPersona', 'error', 'a-alert-danger')
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
